import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBrain, FiCheckCircle } = FiIcons;

const FinalAssessment = ({ assessment, score }) => {
  const getAssessmentColor = (score) => {
    if (score >= 90) return 'text-green-400';
    if (score >= 70) return 'text-blue-400';
    if (score >= 40) return 'text-yellow-400';
    return 'text-red-400';
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.6 }}
      className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-purple-500/20"
    >
      <div className="flex items-center space-x-3 mb-6">
        <SafeIcon icon={FiBrain} className="text-2xl text-purple-400" />
        <h3 className="text-2xl font-bold text-white">🧠 FINAL ASSESSMENT</h3>
      </div>
      <div className="space-y-4">
        {assessment.map((point, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="flex items-start space-x-3 p-4 bg-black/30 rounded-lg border border-purple-500/20"
          >
            <SafeIcon icon={FiCheckCircle} className={`text-lg mt-0.5 flex-shrink-0 ${getAssessmentColor(score)}`} />
            <span className="text-white">{point}</span>
          </motion.div>
        ))}
      </div>
      <div className="mt-8 p-6 bg-gradient-to-r from-purple-600/20 to-pink-600/20 rounded-lg border border-purple-500/30">
        <div className="text-center">
          <h4 className="text-xl font-semibold text-white mb-2">Confidence Level</h4>
          <div className={`text-3xl font-bold ${getAssessmentColor(score)}`}>
            {score >= 90 ? 'Very High' : score >= 70 ? 'High' : score >= 40 ? 'Medium' : 'Low'}
          </div>
          <p className="text-purple-300 mt-2">
            Based on comprehensive OSINT analysis of digital footprint and public records
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default FinalAssessment;